export  function formatNumber(number) {
    if (number){
        const formattedNumber = parseFloat(number).toFixed(2);
        const parts = formattedNumber.toString().split('.');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        return parts.join(",");
    }
    return '0.00'
}

export function calculateDV(nit) {
    nit = nit.replace(/\s|,|\.|-/g, ""); 
    if (isNaN(nit)) return "";
    
    const vpri = [3, 7, 13, 17, 19, 23, 29, 37, 41, 43, 47, 53, 59, 67, 71];
    let sum = 0;
    for (let i = 0; i < nit.length; i++) {
      const digitNit = parseInt(nit[i]);
      sum += digitNit * vpri[nit.length - i - 1];
    }
    const mod = sum % 11;
    return `${ mod > 1 ? 11 - mod : mod}`;
}